import { withLayouts } from 'react-dx'
import { useLingui } from '@lingui/react/macro'

import AntdLayout from '../_layout/layouts/AntdLayout'
import SiteSpecificContextLayout from '../_layout/layouts/SiteSpecificContextLayout'
import RootLayout from '../_layout/layouts/RootLayout'
import DefaultLayout from '../_layout'

import { Banner } from './_blocks/Banner'
import { OurMission } from './_blocks/OurMission'
import { WhyChoose } from './_blocks/WhyChoose'
import GetInTouch from './_blocks/GetInTouch'

import type { NextPage } from 'next'

import LazyImage from '@/components/LazyImage'


import { useConfig } from '@/contexts/SiteContext/hooks';
import { getServerSideData } from '@/helpers/server-data';
const Page: NextPage = () => {
  const { t } = useLingui()

  return (
    <>
      <div className='relative'>
        <LazyImage
          fill
          src={'/images/index/top-bg.jpg'}
          alt={t`About Us`}
          className='max-h-[1150px]'
        />
        <Banner />
      </div>
      <OurMission />
      <WhyChoose />
      <GetInTouch />
    </>
  )
}
const LayoutsPage = withLayouts(Page, [
  (props) => {
    return (
      <DefaultLayout
        {...props}
        main={{ className: 'bg-black', includingHeader: true }}
        header={{ transparentOnScrollTop0: true }}
      />
    )
  },
  (props) => {
    const { seoTitle } = useConfig()

    const { t } = useLingui()

    return (
      <RootLayout
        {...props}
        seo={{
          title: seoTitle(t`About Us`),
          description: t`Discover Tad AI, a cutting-edge AI music generator. Learn about our mission, values, and the team dedicated to delivering exceptional music generation services.`,
        }}
      />
    )
  },
  (props) => {
    return <SiteSpecificContextLayout {...props} />
  },
  AntdLayout,
])

export default LayoutsPage

// eslint-disable-next-line react-refresh/only-export-components
export const getServerSideProps = getServerSideData({ cacheControl: true })(
  () => {},
)
